import styles from "./Input/Input.module.scss";
import cn from "clsx";

interface SelectProps {
  isFullWidth?: boolean;
  value: string;
  onChangeFunc: (value: string) => void;
  options: string[];
  disabled?: boolean;
  values?: Array<string>
  onBlur?: () => void;
  onClick?: () => void;
  id: string;
  className?: string;
  isBorderReq?: boolean;
}

export default function Select({
  isFullWidth = true,
  value,
  onChangeFunc,
  options,
  disabled = false,
  values = [],
  onBlur,
  onClick,
  id = "select",
  className = "",
  isBorderReq = true
}: SelectProps) {
  return (
    <div className={cn(styles.SelectContainer, className, "relative", { ["border border-neutral-200"]: isBorderReq })}>
      <select
        className={`appearance-none lining-nums ${isFullWidth && "w-full"
          } text-stone-500 bg-white text-lg leading-loose tracking-tight outline-none pr-10 ${disabled && "cursor-not-allowed opacity-70"
          } ${styles.selectDropdown}`}
        value={value}
        onChange={(e) => onChangeFunc(e.target.value)}
        disabled={disabled}
        onBlur={onBlur}
        onClick={onClick}
        id={id}
      >
        {options.map((option, i) => (
          <option value={values?.length ? values[i] : option} key={i}>
            {option}
          </option>
        ))}
      </select>
      <div className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2">
        <svg
          width="13"
          height="9"
          viewBox="0 0 13 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 1L6.62222 7L0.999999 1"
            stroke="#686868"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      </div>
    </div>
  );
}
